import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from "../../Context/AuthContext";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_REST_URL;
const style = {
  position: "fixed",
  top: "54%",
  // left: "85vw",
  right: "-175px",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: 400,
  maxHeight: 620,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  overflow: "auto",

  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};
const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const Insurance = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [referrals, setReferrals] = useState([]);
  const [filteredReferrals, setFilteredReferrals] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalDataObj, setModalDataObj] = useState();
  const userId = sessionStorage.getItem("userId");
  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  useEffect(() => {
    console.log(modalDataObj, "modalDataObj");
  }, [modalDataObj]);
  const fetchReferrals = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const apiResponse = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/getOtherInsurance`,
        {},
        {
          headers,
        }
      );

      if (apiResponse?.data?.response) {
        const dataWithIds = apiResponse.data.response.map((item, index) => ({
          ...item,
          id: index + 1,
        }));
        setReferrals(dataWithIds);
        setFilteredReferrals(dataWithIds);
      }
    } catch (error) {
      console.error("Error fetching partners:", error.message);
    }
    setLoading(false);
  };
  console.log("rf", searchQuery);
  console.log("rf", referrals);

  useEffect(() => {
    fetchReferrals();
  }, []);
  useEffect(() => {
    if (searchQuery === "") {
      setFilteredReferrals(referrals); // Show all if no search query
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = referrals.filter((referral) => {
        const fullName =
          `${referral.clientFirstName} ${referral.clientFirstName}`.toLowerCase();

        return fullName.includes(query);
      });
      setFilteredReferrals(filtered);
    }
  }, [searchQuery, referrals]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  //--------------------------------------
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const handleApiCall = async (product) => {
    const payload = {
      userId: userId,
      vendor: "zopper",
      type: "b2b",
      product: product,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/commonEngine/wrapperApiCall`,
        payload
      );
      const redirectionUrl = response?.data?.response?.data?.redirection_url;
      if (redirectionUrl) {
        window.open(redirectionUrl, "_blank");
      } else {
        console.error("Redirection URL not found in the response");
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };
  // const handleApiCall = async (product) => {
  //   const getApiDetailsPayload = {
  //     vendor: "zopper",
  //     type: "b2b",
  //   };

  //   try {
  //     const getApiDetailsResponse = await axios.post(
  //       `${apiUrl}/CCE/api/v1/commonEngine/getApiDetails`,
  //       getApiDetailsPayload
  //     );

  //     const apiDetails = getApiDetailsResponse?.data?.response;

  //     if (apiDetails) {
  //       const { api_url, client_id, client_secret } = apiDetails;

  //       const secondApiPayload = {
  //         client_id,
  //         client_secret,
  //         firstname: sessionStorage.getItem("firstname"),
  //         lastname: sessionStorage.getItem("lastname"),
  //         phone: sessionStorage.getItem("phonenumber"),
  //         code: sessionStorage.getItem("code"),
  //         email: sessionStorage.getItem("email"),
  //         product,
  //         customer_details: {
  //           customer_id: sessionStorage.getItem("userId"),
  //           pan: sessionStorage.getItem("panNumber"),
  //           ckyc_number: sessionStorage.getItem("ckycNumber"),
  //           dob: sessionStorage.getItem("dob"),
  //           Father_name: sessionStorage.getItem("fathername"),
  //           customer_first_name: sessionStorage.getItem("firstname"),
  //           customer_middle_name: sessionStorage.getItem("middlename"),
  //           customer_last_name: sessionStorage.getItem("lastname"),
  //           customer_Phone_nbr: sessionStorage.getItem("phonenumber"),
  //           customer_emai_id: sessionStorage.getItem("email"),
  //         },
  //       };

  //       const secondApiResponse = await axios.post(api_url, secondApiPayload);

  //       const redirectionUrl = secondApiResponse?.data?.data?.redirection_url;
  //       if (redirectionUrl) {
  //         window.open(redirectionUrl, "_blank");
  //       } else {
  //         console.error("Redirection URL not found in the response");
  //       }
  //     } else {
  //       console.error("Failed to fetch API details");
  //     }
  //   } catch (error) {
  //     console.error("API call failed:", error);
  //   }
  // };
  const handleLife = () => handleApiCall("life");
  const handleMotor = () => handleApiCall("motor");
  const handleHealth = () => handleApiCall("health");
  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 80,
      headerClassName: "boldHeader",
    },
    {
      field: "requestedOn",
      headerName: "Requested On",
      valueFormatter: (params) => formatDateString(params.value),
      width: 220,
      headerClassName: "boldHeader",
    },
    {
      field: "clientFirstName",
      headerName: "Requested By",
      renderCell: (params) => (
        <div>
          {params.row.clientFirstName} {params.row.clientLasttName}
        </div>
      ),
      width: 220,
      headerClassName: "boldHeader",
    },

    {
      field: "otherInsurance",
      headerName: "Other Insurance",
      width: 220,
      headerClassName: "boldHeader",
    },
    {
      field: "managerFirstName",
      headerName: "Manager Name",
      renderCell: (params) => (
        <div>
          {params.row.managerFirstName} {params.row.managerLastName}
        </div>
      ),

      width: 220,
      headerClassName: "boldHeader",
    },
  ];
  return (
    <Box sx={styles.main_container}>
      <Paper sx={styles.dashboard_paper}>
        <h3>Insurance</h3>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btnback}
            variant="contained"
            onClick={() => navigate("/employeedashboard")}
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Box
        sx={{
          width: "100%",
          height: "92vh",
          background: "#f2f2f2",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            margin: "10px 20px 20px 20px",
            height: "590px",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 15px",
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              {/* ----------------------------Filter--------------------------------------- */}
              <Box
                sx={{
                  textAlign: "left",
                  position: "relative",
                  margin: "5px 0px",
                }}
              >
                <Typography sx={{ textAlign: "left", fontSize: "13px" }}>
                  Click to purchase Insurance for client
                </Typography>

                <Button
                  onClick={handleLife}
                  sx={{ ...styles.btn, marginLeft: "0px" }}
                  variant="contained"
                >
                  Life
                </Button>

                <Button
                  onClick={handleHealth}
                  sx={styles.btn}
                  variant="contained"
                >
                  Health
                </Button>
                <Button
                  onClick={handleMotor}
                  sx={styles.btn}
                  variant="contained"
                >
                  Motor
                </Button>
                <input
                  style={{
                    marginLeft: "20px",
                    width: "200px",
                    height: "30px",
                    fontSize: "11px",
                    borderRadius: "8px",
                    paddingLeft: "35px",
                  }}
                  type="text"
                  placeholder="Search by Requested By Name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />

                <SearchIcon
                  sx={{
                    position: "absolute",
                    left: "382px",
                    top: "64%",
                    transform: "translateY(-50%)",
                    color: "grey",
                  }}
                />
              </Box>
              <Typography sx={{ textAlign: "left", mb: 1, fontSize: "13px" }}>
                Other Insurance Requested By
              </Typography>
              {/* ---------------------------------------------------------------------- */}
            </Box>
          </Box>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div style={{ height: 500, width: "100%" }}>
              <DataGrid
                rows={filteredReferrals}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                sx={{ ...sxStyles.boldHeader, fontSize: "13px" }}
              />
            </div>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default Insurance;

const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  // btn: {
  //   width: "120px",
  //   margin: "10px 11px",
  //   backgroundColor: "#002C51",
  //   color: "white",
  //   textTransform: "none",
  //   "&:hover": {
  //     background: "#002C51",
  //   },
  // },
  btn: {
    width: "100px",
    margin: "10px 11px",
    backgroundColor: "#002C51",
    color: "black",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(to bottom, #899ED4, #CEDEFF)",
    },
    background: "linear-gradient(to bottom, #CEDEFF, #899ED4)",
    border: "none",
    // padding: "12px 24px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline - block",
    fontSize: "11px",
    cursor: "pointer",
    borderRadius: "5px",
    transition: "background 0.3s ease",
    border: "1px inset grey",
    fontWeight: "bold",
  },
  textfield: {
    width: "340px",
  },
  btnback: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
